module.exports = __webpack_public_path__ + "img/output_main.bed5753c.png";